/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { MimeTypes } from '../engine/mime-types';
import { NameValue } from '../tool/name-value';
import { CommonUtils } from '../tool/common-utils';
import { GedListDto } from '../dto/ged/ged-list.dto';

/**
 * Conversion of Ged data file on server
 */
export class GedRecord {
  public name: string;
  public lastModified: Date;
  public user: string;
  public type: string;
  public metadata: string;
  public dds: NameValue[] = [];
  public position: number;

  constructor(args: GedListDto) {
    this.name = args.FileName;
    this.type = MimeTypes.lookup(args.FileName);
    this.user = args.CreateUser;
    this.metadata = args.Id;
    this.lastModified = CommonUtils.convertStrToDateTime(
      args.CreateDate,
      args.CreateTime,
    );
    this.dds = args.Dds.map((dds) => new NameValue(dds.Code, dds.Value));
    if (Number.isInteger(args.Position)) {
      this.position = args.Position;
    }
  }
}
